import { raw_error, response_t } from 'src/types'

import { DESCRIPTIONS_FE } from './errors'

export const to_error = <T>(r_error: raw_error, saga_type?: string): response_t<T> => {
  const error = r_error?.response?.data
  return {
    error: {
      status: error?.status,
      code: error?.code,
      description_be: error?.message,
      description_fe: DESCRIPTIONS_FE[error?.code || ''] || 'Sì è verificato un errore temporaneo', // TODO
      saga_type,
    },
  }
}
